import React, { createContext } from 'react';

const MainContext = createContext();
export default MainContext;

//mainContext.Provider
//mainContext.Consumer
